import { useEffect, useState } from "react";
import { styles } from "../../styles";
import { ErrorNote } from "../common";
import { useShop } from "../../context/ShopContext";
import { useToast } from "../../context/ToastContext";
import { saveShopConfig } from "../../data/config";
import { logAudit } from "../../data/audit";

export function MessageCard() {
  const { config } = useShop();
  const notify = useToast();
  const [draft, setDraft] = useState(config.adminMessage);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => setDraft(config.adminMessage), [config.adminMessage]);

  const publish = async () => {
    setError(null);
    setBusy(true);
    try {
      await saveShopConfig({ adminMessage: draft });
      void logAudit("Updated the customer message");
      notify("Message published to the booking page.");
    } catch {
      setError("We could not publish your message. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  const clear = async () => {
    setError(null);
    setBusy(true);
    try {
      await saveShopConfig({ adminMessage: "" });
      setDraft("");
      void logAudit("Cleared the customer message");
      notify("Message cleared.");
    } catch {
      setError("We could not clear your message. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={styles.card}>
      <h2 style={styles.cardTitle}>Message to customers</h2>
      <p style={styles.sub}>Shown at the top of the booking page. Leave empty to hide it.</p>
      {error && <ErrorNote>{error}</ErrorNote>}
      <textarea
        value={draft} onChange={(e) => setDraft(e.target.value)}
        placeholder="e.g. Running 15 minutes behind today, thanks for your patience!"
        className="input" style={styles.textarea} rows={3} aria-label="Customer message"
      />
      <div style={styles.msgActions}>
        <button className="ghost" style={styles.ghostSm} onClick={clear} disabled={busy}>Clear</button>
        <button className="primary" style={styles.primarySm} onClick={publish} disabled={busy}>
          {busy ? "Publishing…" : "Publish message"}
        </button>
      </div>
      {draft.trim() && (
        <div style={styles.previewBox}>
          <span style={styles.previewLabel}>Preview</span>
          <div style={styles.bannerMini}>
            <span style={styles.bannerDot} aria-hidden="true" />
            <p style={styles.bannerBody}>{draft}</p>
          </div>
        </div>
      )}
    </div>
  );
}
